/* eslint-disable no-throw-literal */
const atlasServiceUrl = () => {
  const url = process.env.ATLAS_SERVICE_URL;
  if (!url) {
    throw 'Unknown environment.';
  }
  return url;
};

export default atlasServiceUrl;
